import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'firstLetter',
})
export class FirstLetterPipe implements PipeTransform {
  transform(value?: string): string {
    if (!value) return '';
    return value[0];
  }
}
